var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-us"},[_c('img',{staticClass:"about-us-img",attrs:{"src":_vm.appData.merRegardUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }